var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import PaymentEntry from 'containers/PaymentEntry';
import { CardDetailsWrapper } from './styles';
var stripePromise = loadStripe(process.env.STRIPE_KEY || '');
export var ConfigureAccountCardDetailsModal = function (_a) {
    var organization = _a.organization, purchasedDevPlan = _a.purchasedDevPlan, on3DSSuccess = _a.on3DSSuccess, paymentModalState = _a.paymentModalState, onCardAssignStatusChanged = _a.onCardAssignStatusChanged, setLoading = _a.setLoading;
    return (_jsx(CardDetailsWrapper, { children: _jsx(Elements, __assign({ stripe: stripePromise }, { children: _jsx(PaymentEntry, { contentOnly: true, organization: organization, modalMode: "update", purchasedDevPlan: purchasedDevPlan, on3DSSuccess: on3DSSuccess, paymentModalState: paymentModalState, onCardAssignStatusChanged: onCardAssignStatusChanged, setLoading: setLoading }) })) }));
};
